module.exports = __webpack_public_path__ + "static/y4420_11-ec7e597457996fc3fde7782c4999dc4b.jpg";